export default __webpack_public_path__ + "static/media/salesforce.ca4d4b40.png";